<template>
  <div class="services">
    <headd></headd>
    <indexswiper :swiper_list="swiper_list"></indexswiper>
    <serviceslist
      :compayservicelist="compayservicelist_1"
      :title="list_1"
    ></serviceslist>
    <serviceslist
      :compayservicelist="compayservicelist_2"
      :title="list_2"
    ></serviceslist>
    <serviceslist
      :compayservicelist="compayservicelist_3"
      :title="list_3"
    ></serviceslist>

    <indextel :solgan="solgan" :num="dy_title_t1" :service="service"></indextel>
    <maybe :is_include="name"></maybe>
    <!-- <common-poup ref="mychild" :service="service2"></common-poup> -->
    <foot></foot>
  </div>
</template>

<script>
import indexswiper from "../components/indexswiper.vue";
import indextel from "../components/indextel.vue";
import maybe from "../components/maybe.vue";
import serviceslist from "../components/serviceslist.vue";
import headd from "../components/head";
import foot from "@/components/foot";
import {
  getcompanyServicebanner,
  getcompayservice,
  getleads,
  getindexPageData
} from "./api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      name: "公司服务",
      solgan: "更多服务 立即咨询",
      service: "公司服务咨询",
      service2: "",
      indicatorDots: true,
      autoplay: true,
      interval: 2000,
      duration: 500,
      indicatorColor: "rgba(255, 255, 255, .3)",
      indicatorActivecolor: "#FFFFFF",
      swiper_list: [],
      compayservicelist_1: [],
      compayservicelist_2: [],
      compayservicelist_3: [],
      list_1: {
        icon: "../../static/otherpage/icon_t_11.png",
        title: "品牌设计"
      },
      list_2: {
        icon: "../../static/otherpage/icon_t_12.png",
        title: "IT/软件"
      },
      list_3: {
        icon: "../../static/otherpage/icon_t_13.png",
        title: "营销推广"
      },
      dy_title_t1: ""
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    indexswiper,
    maybe,
    indextel,
    serviceslist,
    headd,
    foot
    //commonPoup
  },
  async mounted() {
    var swiperr = await getcompanyServicebanner();
    this.swiper_list = swiperr.data.data.banner;
    this.$nextTick(function() {
      this.swiper();
    });

    var indexpage = await getindexPageData();
    this.dy_title_t1 = indexpage.data.data.t1;

    var compayservicelist_1 = await getcompayservice("branddesign");
    this.compayservicelist_1 = compayservicelist_1.data.data;

    var compayservicelist_2 = await getcompayservice("itsoftware");
    this.compayservicelist_2 = compayservicelist_2.data.data;

    var compayservicelist_3 = await getcompayservice("marketing");
    this.compayservicelist_3 = compayservicelist_3.data.data;
  },
  methods: {
    swiper() {
      new Swiper(".banner", {
        loop: true,
        observer: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000
      });
    }
  }
};
</script>

<style lang="less">
.container {
  @media (max-width: 991px) {
    padding: 0 0rem;
  }
}

.services {
  flex-direction: column;
  @media (max-width: 991px) {
    width: 6.86rem;
  }
  margin: auto;

  .index-tel {
    margin-top: 0.6rem;
    margin-bottom: 0 !important;
  }

  .services_recommd {
    flex-direction: column;
  }

  .services_list {
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;

    .services_item {
      width: 100%;
      height: 0.92rem;
      background: #1395ff;
      border-radius: 0.12rem;
      margin-bottom: 0.2rem;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 0.24rem;
      display: flex;
      cursor: pointer;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }

      img {
        width: 0.35rem;
        height: 0.35rem;
        margin-right: 0.1rem;
      }

      .name {
        // width: 1.2rem;
        // text-align: justify;
      }
    }

    .services_item.bg {
      background: url(../../static/otherpage/icon_9.png) no-repeat;
      background-size: cover;
      font-size: 0.26rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/services.vue